import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const TimeToHireRole: React.FC = () => {
  const { t } = useI18n('state-of-hiring');
  const { locale } = useRouter();

  const GRAPH_01_TIME_TO_HIRE_BY_ROLE = [
    { label: locale === 'es' ? 'Diseño UX/UI' : 'UX/UI Design', value: 65 },
    { label: locale === 'es' ? 'Ventas' : 'Sales', value: 62 },
    {
      label: locale === 'es' ? 'Desarrollo Frontend' : 'Frontend Development',
      value: 57
    },
    { label: 'Data', value: 52 },
    { label: locale === 'es' ? 'Otros' : 'Other', value: 52 },
    { label: locale === 'es' ? 'Liderazgo Técnico' : 'Tech Lead', value: 50 },
    { label: 'QA & Testing', value: 48 },
    {
      label: 'Engineering Management',
      value: 48
    },
    {
      label: 'Product Management',
      value: 46
    },
    {
      label: locale === 'es' ? 'Infraestructura' : 'Infraestructure',
      value: 44
    },
    {
      label: locale === 'es' ? 'Desarrollo Backend' : 'Backend Development',
      value: 43
    },
    {
      label: locale === 'es' ? 'Desarrollo Mobile' : 'Mobile Development',
      value: 41
    },
    {
      label:
        locale === 'es' ? 'Desarrollo Full-Stack' : 'Full-Stack Development',
      value: 36
    },
    {
      label:
        locale === 'es' ? 'Arquitectura de Software' : 'Software Architecture',
      value: 29
    }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer width="99%" height={440}>
          <BarChart data={GRAPH_01_TIME_TO_HIRE_BY_ROLE} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 10 }}
            />
            <YAxis
              type="category"
              dataKey="label"
              tickLine={false}
              width={190}
            />
            <Tooltip
              cursor={{ fill: '#dffffd' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [
                value + ' ' + t('state-of-hiring.time-to-hire.days'),
                ''
              ]}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="#147092" barSize={12} radius={6} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default TimeToHireRole;
